import {useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useAuth} from "../../../../contexts/auth";

export default function EEProExternalLoginForm() {
    const { quoteId, token } = useParams();
    const { externalLogin } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (token) {
            externalLogin(token);
            navigate('/cfi/easy-estimator/' + quoteId);
        }
    }, [])

    return (
        <div>Loading...</div>
    );
}
